// web/src/privacy/sensitivityLevels.js
//
// Phase 4 — Privacy Architecture: frontend mirror of
// `backend/src/privacy/sensitivityLevels.js`.
//
// The web app is a separate package from the backend, so this is an
// intentional, minimal mirror (same pattern as NavigationRegistry's
// independent role/permission checks) — it must stay in sync with the
// backend's `SENSITIVITY_LEVELS`/`SENSITIVITY_LEVEL_ORDER`. Used by
// NavigationRegistry (`requiredSensitivity`) and WidgetSecurityService
// (`supportedSensitivity`) to make client-side visibility decisions.
// Server-side enforcement always remains authoritative.

export const SENSITIVITY_LEVELS = Object.freeze({
  PUBLIC: "PUBLIC",
  COMMUNITY: "COMMUNITY",
  CHURCH_PRAYER: "CHURCH_PRAYER",
  MEMBERS_ONLY: "MEMBERS_ONLY",
  GROUP_LEADER: "GROUP_LEADER",
  MINISTRY_LEADER: "MINISTRY_LEADER",
  CARE_TEAM: "CARE_TEAM",
  PASTORAL: "PASTORAL",
  ELDERS_ONLY: "ELDERS_ONLY",
  CONFIDENTIAL: "CONFIDENTIAL",
  SYSTEM: "SYSTEM",
});

// Low -> high. A principal cleared for level N may view any record at level
// <= N.
export const SENSITIVITY_LEVEL_ORDER = Object.freeze([
  SENSITIVITY_LEVELS.PUBLIC,
  SENSITIVITY_LEVELS.COMMUNITY,
  SENSITIVITY_LEVELS.CHURCH_PRAYER,
  SENSITIVITY_LEVELS.MEMBERS_ONLY,
  SENSITIVITY_LEVELS.GROUP_LEADER,
  SENSITIVITY_LEVELS.MINISTRY_LEADER,
  SENSITIVITY_LEVELS.CARE_TEAM,
  SENSITIVITY_LEVELS.PASTORAL,
  SENSITIVITY_LEVELS.ELDERS_ONLY,
  SENSITIVITY_LEVELS.CONFIDENTIAL,
  SENSITIVITY_LEVELS.SYSTEM,
]);

export function sensitivityRank(level) {
  const index = SENSITIVITY_LEVEL_ORDER.indexOf(level);
  return index === -1 ? SENSITIVITY_LEVEL_ORDER.indexOf(SENSITIVITY_LEVELS.MEMBERS_ONLY) : index;
}

/**
 * True if a principal cleared up to `maxAllowedLevel` may view a record at
 * `level` (i.e. `level <= maxAllowedLevel`).
 */
export function meetsSensitivityRequirement(maxAllowedLevel, level) {
  return sensitivityRank(level) <= sensitivityRank(maxAllowedLevel);
}
